/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation
// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Jayesh Lokhande",
  title: "Hey, I'm Jayesh",
  subTitle: emoji(
    "A passionate Backend Developer 🚀 from India. Enthusiatic about Systems and Algorithms. Currently active as a Java Developer at Digitate - A TCS Venture"
  ),
  resumeLink:
    "https://drive.google.com/file/d/1Np55HKQWv7ZZys24dkFQQKTtLmPHFvWb/view?usp=sharing", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/jlokhande46",
  linkedin: "https://www.linkedin.com/in/jayesh-lokhande/",
  gmail: "jlokhande046@gmail.com",
  gitlab: "https://gitlab.com/jlokhande46",
  facebook: "https://www.facebook.com/jayeshlokhande",
  medium: "https://medium.com/@jlokhande46",
  stackoverflow: "https://stackoverflow.com/users/10422806/saad-pasta",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "System Engineer and Backend Developer who is fond of exploring and tinkering with up-and-coming tech",
  skills: [
    emoji(
      "⚡ Develop highly Scalable Systems for applications"
    ),
    emoji("⚡ Enterprise Spring Boot Applications and Node.js Applications"),
    emoji(
      "⚡ Integration of databases such as Postgres / Hadoop / Neo4j"
    )
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

softwareSkills: [
	  {
      skillName: "Java",
      fontAwesomeClassname: "fab fa-sass",
		icon: "logos:java"
    },
	  {
      skillName: "Spring",
      fontAwesomeClassname: "fab fa-sass",
		icon: "logos:spring"
    },
	  {
      skillName: "Postgresql",
      fontAwesomeClassname: "fab fa-sass",
		icon: "logos:postgresql"
    },
	  {
      skillName: "Hadoop",
      fontAwesomeClassname: "fab fa-sass",
		icon: "logos:hadoop"
    },
	  {
      skillName: "Hbase",
      fontAwesomeClassname: "fab fa-sass",
		icon: "logos:hbase"
    },
	  {
      skillName: "Neo4j",
      fontAwesomeClassname: "fab fa-sass",
		icon: "logos:neo4j"
    },
	  {
      skillName: "Python",
      fontAwesomeClassname: "fab fa-sass",
		icon: "logos:python"
    },{
      skillName: "Nodejs",
      fontAwesomeClassname: "fab fa-sass",
		icon: "logos:nodejs"
    },
	  {
      skillName: "React",
      fontAwesomeClassname: "fab fa-sass",
		icon: "logos:react"
    },
	  {
      skillName: "MongoDB",
      fontAwesomeClassname: "fab fa-sass",
		icon: "logos:mongodb"
    },
    {
      skillName: "html-5",
      fontAwesomeClassname: "fab fa-html5",
	  icon: "logos:html-5"
    },
    {
      skillName: "css3",
      fontAwesomeClassname: "fab fa-css3-alt",
		icon: "logos:css-3"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Harvard University",
      logo: require("./assets/images/harvardLogo.png"),
      subHeader: "Master of Science in Computer Science",
      duration: "September 2017 - April 2019",
      desc: "Participated in the research of XXX and published 3 papers.",
      descBullets: [
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit"
      ]
    },
    {
      schoolName: "Stanford University",
      logo: require("./assets/images/stanfordLogo.png"),
      subHeader: "Bachelor of Science in Computer Science",
      duration: "September 2013 - April 2017",
      desc: "Ranked top 10% in the program. Took courses about Software Engineering, Web Security, Operating Systems, ...",
      descBullets: ["Lorem ipsum dolor sit amet, consectetur adipiscing elit"]
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Frontend/Design", //Insert stack or technology you have experience in
      progressPercentage: "90%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Backend",
      progressPercentage: "70%"
    },
    {
      Stack: "Programming",
      progressPercentage: "60%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Backend Engineer",
      company: "Digitate - A TCS Venture",
      companylogo: require("./assets/images/digitate.png").default,
      date: "August 2020 – Present",
      desc: "Working as a Java backend developer, designed and developed RESTful web services using Spring Boot",
      descBullets: [
        "Designed and Implemented APIs for 'Incremental Analysis' which reduced execution time of the algorithms by 60%"
,"Worked on microservices to serve multiple applications that consume data from subscribed message queues using Apache camel and RabbitMQ"
,"Worked on PostgreSQL database and optimization of HBase and Neo4j backend APIs for improving performance by up to 40%"
      ]
    },
    {
      role: "R&D Intern",
      company: "Ramrao Adik Institute of Technology",
      companylogo: require("./assets/images/rait-try.png").default,
      date: "Aug 2018 – Oct 2018",
      desc: "Worked as R&D intern on the RAIT Cluster Project at the High Performance Computing Lab",
      descBullets: [
        "Configured MPI Endpoints on 32 Linux machines and connected them through OpenSSH Server on LAN",
        "Emulated heavy matrix multiplication operations to document performance efficiency"
      ]
    },
	  {
      role: "Web Developer",
      company: "Service4Startup",
      companylogo: require("./assets/images/service4startup.png").default,
      date: "Dec 2018 – Feb 2019",
      desc: "Worked as a web developer intern",
	  descBullets: ["Developed College review website which will act as a template for various colleges.", 
					"One can create a website for a college within minutes by changing the required details."]
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Academic & Professional Projects",
  subtitle: "SOME INTERESTING VENTURES I HAVE WORKED ON IN MY STUDENT AND PROFESSIONAL LIFE",
  projects: [
    {
      image: require("./assets/images/driver-detection.jpg").default,
      projectName: "Driver Alertness Detection",
      projectDesc: "A system deployed on the vehicular dashboard camera to monitor the heartbeat and facial features of the driver to detect drowsiness and issue alerts",
      footerLink: [
        {
          name: "Visit Project",
          url: "https://github.com/jlokhande46/driver-alertness-detection"
        }
        //  you can add extra buttons here.
      ]
    },
	  {
      image: require("./assets/images/audio-sep.jpg").default,
      projectName: "Enhanced Audio Source Separation",
      projectDesc: "A system to perform accurate source separation on musical audio to split the track into four stems, i.e. vocals, drums, bass and accompaniment, using hybrid neural networks",
      footerLink: [
        {
          name: "Visit Project",
          url: "http://saayahealth.com/"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/farmeasy.jpg").default,
      projectName: "Krushak-Unnati (Farmeasy)",
      projectDesc: "An AI-powered chatbot which enables farmers to obtain expert guidance and grievance redressal through features like Best Crop Suggestion & Crop Disease Detection",
      footerLink: [
        {
          name: "Visit Project",
          url: "https://github.com/jlokhande46/krushak-unnati"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Hackathons, Research Work, Professional Affiliations & Certifications",

  achievementsCards: [
    {
      title: "Hackathons",
      subtitle: "Domains- Machine Learning, Web Development",
      image: require("./assets/gifs/hackathon-final.gif"),
		descBullets: [
        "Second Place @ NIT Raipur's CodeUtsava 4.0",
		"Third Place @ SRM Andhra's SRMHack ",
        "Best Design @ RAIT's BitCamp 2019",
        "Finalist @ TSEC Hacks 2019",
      ],
      footerLink: [
        {
          name: "CodeUtsava 4.0",
          url: "https://drive.google.com/file/d/1DL-Gto3SWKMSCFZWRBaHvYLwn-12O_Oz/view?usp=sharing"
        },
		  {
          name: "SRMHack",
          url: "https://drive.google.com/file/d/1LIfaiZE43oOFZea_5JsOeH64Z1ruawWR/view?usp=sharing"
        }
      ]
    },
    {
      title: "Research Papers",
      subtitle: "Topics- Deep Learning, Machnine Learning, Artificial Intelligence",
      image: require("./assets/gifs/ai-gif.gif"),
      descBullets: [
        "Enhanced Audio Source Separation and Musical Component Analysis"
      ],
      footerLink: [
        {
          name: "Research [1]",
          url: "https://ieeexplore.ieee.org/document/9358850"
        }
      ]
    },
    {
      title: "Affiliations & Certifications",
      subtitle: "Topics- Artificial Intelligence, Data Analytics",
      image: require("./assets/gifs/micpython.gif"),
      descBullets: [
        "College Campus Ambassador at Interview bit (now Scaler)",
        "College Campus Ambassador at Coding Ninja",
        "Python Certification issued by Microsoft"
      ],
      footerLink: [
        // {name: "Google", url: "https://courses.cognitiveclass.ai/certificates/53b82d96041b4399801af075ec2ff813"},
        {
          name: "Certificate",
          url: "https://www.credly.com/badges/4c95b4b7-b3a0-4a3f-bf83-cbada4fbe206/linked_in_profile"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: true // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  number: "+92-0000000000",
  email_address: "saadpasta70@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: true // Set true to display this section, defaults to false
};

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails
};
